import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faLock,
  faCircleXmark,
  faCheck,
  faTable,
  faPrint,
  faArrowRotateLeft,
  faPowerOff,
  faBars,
  faArrowsRotate,
  faMoneyBill,
  faReceipt,
  faTriangleExclamation,
  faEye,
  faArrowLeft,
  faFileExcel,
  faSpinner
} from '@fortawesome/free-solid-svg-icons'

/**
 * Registers the Font Awesome icon component and adds all Yango Report App icons
 * to the SVG library. Safe to call once at application bootstrap.
 *
 * @returns void
 */
export function registerFontAwesomeIcons(): void {
  Vue.component('font-awesome-icon', FontAwesomeIcon)
  library.add(
    faLock,
    faCircleXmark,
    faCheck,
    faTable,
    faPrint,
    faArrowRotateLeft,
    faPowerOff,
    faBars,
    faArrowsRotate,
    faMoneyBill,
    faReceipt,
    faTriangleExclamation,
    faEye,
    faArrowLeft,
    faFileExcel,
    faSpinner
  )
}

registerFontAwesomeIcons()